// extracted by mini-css-extract-plugin
export default {"dataUser__card":"style_dataUser__card__YwEhR","dataUser__cardTitle":"style_dataUser__cardTitle__yXLrP"};